import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 8px 12px;
  box-sizing: border-box;
  max-width: 472px;
  width: 100%;
  > * {
    box-sizing: border-box;
  }
  &.loading {
    position: relative;
  }
  &.loading::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(16, 21, 26, 0.72) url('/images/loader.svg') no-repeat 50%;
    background-size: 35px auto;
    border-radius: 10px;
  }

  input {
    box-sizing: border-box;
    flex: 1 1 auto;
    min-width: 0;
    max-width: 260px;
    height: 46px;
    padding: 0 14px;
    font-size: 22px;
    font-weight: 600;
    letter-spacing: 1px;
    text-align: center;
    color: #e6eaec;
    background-color: #10151a;
    border: 1px solid #3d4952;
    border-radius: 10px;
    outline: none;
    transition: border-color 0.15s ease-in, box-shadow 0.15s ease-in, background-color 0.15s ease-in;
  }
  input::placeholder {
    color: #7a838a;
    font-weight: 400;
    letter-spacing: normal;
  }
  input:hover:not(:disabled) {
    border-color: #4a5763;
  }
  input:focus {
    border-color: #47b972;
    box-shadow: 0 0 0 3px rgba(71, 185, 114, 0.22);
  }
  input:disabled {
    color: #aab2b8;
    background-color: #141c18;
    border-color: #2c353d;
    cursor: default;
  }
`;

export const Label = styled.label`
  flex: 1 0 100%;
  margin: 0;
  text-align: center;
  white-space: nowrap;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #7a838a;
`;

export const Button = styled.button`
  box-sizing: border-box;
  flex: 0 0 auto;
  height: 46px;
  padding: 0 20px;
  font-family: inherit;
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0.2px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #e6eaec;
  background: #1a2429;
  border: 1px solid #3d4952;
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(16, 24, 32, 0.18), inset 0 1px 0 rgba(255, 255, 255, 0.04);
  transition: background 0.15s ease-in, border-color 0.15s ease-in, color 0.15s ease-in;
  &:hover {
    background: #232e35;
    border-color: #47b972;
    color: #ffffff;
  }
  &:active {
    background: #17201d;
    border-color: #3aa863;
  }
`;
